module.exports = __webpack_public_path__ + "assets/img/giran.f35ea65f.jpg";